import { Cookies } from '@/models/cookies';

export class BlockTesting {
    public constructor(specs: string|undefined){
        let info = Cookies.get('info-log');
        if(specs && info == '1'){
            this._createData(specs);
        }
    }

    protected _createData(specs: string){
        let json = atob(specs);
        if(json){
            let data = JSON.parse(json);
            if(data){
                this._detectCampaign(data);
            }
        }
    }

    protected _detectCampaign(data: any){
        let type: string = data?.showMore?.urlDetail?.type ?? '-';
        if(type.toLocaleUpperCase() != 'CAMPAIGN'){
            return;
        }
        let url  = data?.showMore?.urlDetail?.url ?? '-';
        let id   = data?.showMore?.urlDetail?.id ?? '-';
        let win  = (window as any);
        let list = win?.campaign_list ?? [];
        list.push({id,url});
        win.campaign_list = list;
    }
}